import type { Action } from 'src/types';

export enum Actions {
  SUMMARY_UPDATE_START = 'SUMMARY_UPDATE_START',
  SUMMARY_UPDATE_SUCCESS = 'SUMMARY_UPDATE_SUCCESS',
  SUMMARY_UPDATE_FAILURE = 'SUMMARY_UPDATE_FAILURE',
}

export type SummaryAction =
  | (Action<Actions.SUMMARY_UPDATE_START> & {
      payload: { newSummary: string };
    })
  | Action<Actions.SUMMARY_UPDATE_SUCCESS>
  | (Action<Actions.SUMMARY_UPDATE_FAILURE> & {
      payload: { error: Error };
    });
